import { render, staticRenderFns } from "./NumbersOrdersButton.vue?vue&type=template&id=10ba1523&scoped=true"
import script from "./NumbersOrdersButton.vue?vue&type=script&lang=js"
export * from "./NumbersOrdersButton.vue?vue&type=script&lang=js"
import style0 from "./NumbersOrdersButton.vue?vue&type=style&index=0&id=10ba1523&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ba1523",
  null
  
)

export default component.exports